var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-data" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12 col-lg-11" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "detail" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 brdr-right" }, [
                _c("div", { staticClass: "user-form" }, [
                  _c("div", { staticClass: "detail-form form" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__blck" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [_vm._v("Phone number")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", title: "Phone number" },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: function($event) {
                              return _vm.formControlBlur($event)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group disabled active",
                          class: { disabled: _vm.editInput }
                        },
                        [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Phone number")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editable,
                                expression: "editable"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              disabled: _vm.editInput,
                              value: "editable",
                              title: "Phone number"
                            },
                            domProps: { value: _vm.editable },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.editable = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "edit",
                              on: {
                                click: function($event) {
                                  _vm.editInput = !_vm.editInput
                                }
                              }
                            },
                            [_vm._v("Edit")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group disabled" }, [
                        _c(
                          "label",
                          {
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [_vm._v("Personnummer")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled: "",
                            title: "Phone number"
                          },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: function($event) {
                              return _vm.formControlBlur($event)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(7)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-form form" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__blck" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group dirty active",
                          class: { active: _vm.checkClass(_vm.streetAddres) }
                        },
                        [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Street address")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.streetAddres,
                                expression: "streetAddres"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", title: "streetAddres" },
                            domProps: { value: _vm.streetAddres },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.streetAddres = $event.target.value
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group error" }, [
                        _c(
                          "label",
                          {
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [_vm._v("Post code")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", title: "Phone number" },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: function($event) {
                              return _vm.formControlBlur($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "error-text" }, [
                          _vm._v("Please enter your address")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [_vm._v("Post office")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", title: "Phone number" },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: function($event) {
                              return _vm.formControlBlur($event)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group label-group" }, [
                        _c(
                          "label",
                          {
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [_vm._v("Area ID")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", title: "Phone number" },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: function($event) {
                              return _vm.formControlBlur($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "labeled",
                          class: { active: _vm.active1 },
                          on: {
                            click: function($event) {
                              _vm.active1 = !_vm.active1
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.active1
                          ? _c(
                              "div",
                              {
                                staticClass: "mini-popup",
                                class: { active: _vm.active1 },
                                on: {
                                  click: function($event) {
                                    _vm.active1 = !_vm.active1
                                  }
                                }
                              },
                              [_vm._m(9)]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "address-form form" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form__blck" },
                      [
                        _c("div", { staticClass: "form-group checkbox-item" }, [
                          _c("label", [_vm._v("Same as plant address:")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "checkbox-blue" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkbox,
                                  expression: "checkbox"
                                }
                              ],
                              attrs: { type: "checkbox", title: "title" },
                              domProps: {
                                checked: Array.isArray(_vm.checkbox)
                                  ? _vm._i(_vm.checkbox, null) > -1
                                  : _vm.checkbox
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.checkbox,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkbox = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkbox = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkbox = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "box" })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.checkbox
                            ? _c("div", { staticClass: "form-group dirty" }, [
                                _c(
                                  "label",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.forLabelClick($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Street address")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.streetAddres,
                                      expression: "streetAddres"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    title: "streetAddres"
                                  },
                                  domProps: { value: _vm.streetAddres },
                                  on: {
                                    focus: function($event) {
                                      return _vm.formControlFocus($event)
                                    },
                                    blur: function($event) {
                                      return _vm.formControlBlur($event)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.streetAddres = $event.target.value
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.checkbox
                            ? _c("div", { staticClass: "form-group error" }, [
                                _c(
                                  "label",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.forLabelClick($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Post code")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    title: "Phone number"
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.formControlFocus($event)
                                    },
                                    blur: function($event) {
                                      return _vm.formControlBlur($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error-text" }, [
                                  _vm._v("Please enter your address")
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.checkbox
                            ? _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.forLabelClick($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Post office")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    title: "Phone number"
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.formControlFocus($event)
                                    },
                                    blur: function($event) {
                                      return _vm.formControlBlur($event)
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-form form" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__blck" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group date_picker error",
                          class: { active: _vm.dateOpen }
                        },
                        [
                          _c(
                            "label",
                            {
                              attrs: { for: "" },
                              on: {
                                click: function($event) {
                                  return _vm.formDateLabelOpen($event)
                                }
                              }
                            },
                            [_vm._v("Choose date")]
                          ),
                          _vm._v(" "),
                          _c("datepicker", {
                            attrs: { "input-class": "form-control" },
                            on: {
                              opened: function($event) {
                                return _vm.formDateOpen($event)
                              },
                              closed: function($event) {
                                return _vm.formDateClose($event)
                              },
                              click: function($event) {
                                return _vm.ClickEvent($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "error-text" }, [
                            _vm._v("Please enter your date")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group date_picker",
                          class: { active: _vm.dateOpen }
                        },
                        [
                          _c(
                            "label",
                            {
                              attrs: { for: "" },
                              on: {
                                click: function($event) {
                                  return _vm.formDateLabelOpen($event)
                                }
                              }
                            },
                            [_vm._v("Choose date")]
                          ),
                          _vm._v(" "),
                          _c("datepicker", {
                            attrs: { "input-class": "form-control" },
                            on: {
                              opened: function($event) {
                                return _vm.formDateOpen($event)
                              },
                              closed: function($event) {
                                return _vm.formDateClose($event)
                              },
                              click: function($event) {
                                return _vm.ClickEvent($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isMobile
                        ? _c("div", { staticClass: "form-group terms error" }, [
                            _vm._m(12),
                            _vm._v(" "),
                            _vm._m(13)
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isMobile
                        ? _c(
                            "div",
                            {
                              staticClass: "form-group check-group terms error"
                            },
                            [
                              _vm._m(14),
                              _vm._v(" "),
                              _vm._m(15),
                              _vm._v(" "),
                              _c("span", { staticClass: "error-text" }, [
                                _vm._v("Please enter your date")
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "contract-info" }, [
                  _vm._m(16),
                  _vm._v(" "),
                  _vm._m(17),
                  _vm._v(" "),
                  _c("div", { staticClass: "contract__data" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _vm._m(19),
                    _vm._v(" "),
                    _vm._m(20),
                    _vm._v(" "),
                    _c("div", { staticClass: "bindings" }, [
                      _c(
                        "div",
                        {
                          staticClass: "collapsible__el ",
                          class: { active: _vm.collapses1 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title_el",
                              on: {
                                click: function($event) {
                                  _vm.collapses1 = !_vm.collapses1
                                }
                              }
                            },
                            [
                              _vm._m(21),
                              _vm._v(" "),
                              _c("p", { staticClass: "min p-blue" }, [
                                _vm._v("9 months")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.collapses1
                              ? _c("div", { staticClass: "content" }, [
                                  _c("p", { staticClass: "min-min" }, [
                                    _vm._v(
                                      "If the consumer chooses to break the contract entered in early, the Lighthouse has the right to charge a ransom fee. This exercise fee is calculated at 20% of the agreed energy price for estimated consumption during the remaining part of the contract period plus an administrative fee of SEK 450 incl. VAT. The remaining contract period is counted in whole months. The monthly consumption is calculated as one twelfth of the annual consumption stated by the electricity grid owner last. At the customer's definitive relocation, where no new plant is put into use, the agreement can be terminated prematurely without a ransom charge being charged."
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(22),
                    _vm._v(" "),
                    _c("div", { staticClass: "price__info" }, [
                      _c(
                        "div",
                        {
                          staticClass: "collapsible__el",
                          class: { active: _vm.collapses2 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title_el",
                              on: {
                                click: function($event) {
                                  _vm.collapses2 = !_vm.collapses2
                                }
                              }
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "p-white Raleway p-bold" },
                                [_vm._v("Fixed Price")]
                              ),
                              _vm._v(" "),
                              _vm._m(23)
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "fade" } }, [
                            _vm.collapses2
                              ? _c("div", { staticClass: "content" }, [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-8" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "Raleway min p-dgrey"
                                          },
                                          [
                                            _c("b", [
                                              _vm._v("Electricity price")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "p-gray2 minimum" },
                                          [
                                            _vm._v(
                                              "(incl. electricity certificate, excl. VAT)"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4" }, [
                                      _c("div", { staticClass: "cost" }, [
                                        _c(
                                          "p",
                                          { staticClass: "p-dgrey med-max" },
                                          [_vm._v("45.90")]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-8" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "Raleway min p-dgrey"
                                          },
                                          [
                                            _c("b", [
                                              _vm._v("Electricity price")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "p-gray2 minimum" },
                                          [
                                            _vm._v(
                                              "(incl. electricity certificate, excl. VAT)"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4" }, [
                                      _c("div", { staticClass: "cost" }, [
                                        _c(
                                          "p",
                                          { staticClass: "p-dgrey med-max" },
                                          [_vm._v("45.90")]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-8" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "Raleway min p-dgrey"
                                          },
                                          [
                                            _c("b", [
                                              _vm._v("Electricity price")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "p-gray2 minimum" },
                                          [
                                            _vm._v(
                                              "(incl. electricity certificate, excl. VAT)"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4" }, [
                                      _c("div", { staticClass: "cost" }, [
                                        _c(
                                          "p",
                                          { staticClass: "p-dgrey med-max" },
                                          [_vm._v("45.90")]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-8" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "Raleway min p-dgrey"
                                          },
                                          [
                                            _c("b", [
                                              _vm._v("Electricity price")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "p-gray2 minimum" },
                                          [
                                            _vm._v(
                                              "(incl. electricity certificate, excl. VAT)"
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-4" }, [
                                      _c("div", { staticClass: "cost" }, [
                                        _c(
                                          "p",
                                          { staticClass: "p-dgrey med-max" },
                                          [_vm._v("45.90")]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._m(24)
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isMobile
                      ? _c("div", { staticClass: "form-group terms" }, [
                          _vm._m(25),
                          _vm._v(" "),
                          _vm._m(26)
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(27)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-row" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("p", { staticClass: "p-title Raleway p-black" }, [
            _c("b", [_vm._v("User data request")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
            _vm._v(
              "You only need to fill in your details below and then click Continue.\n                                The information below needs your new electricity trading company in order for a change to be carried out."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "images__blck" }, [
      _c("div", { staticClass: "row justify-content-between" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "img__item" }, [
            _c("img", { attrs: { src: "/img/candel.svg", alt: "" } }),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v("A switch never causes any power failure")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "img__item" }, [
            _c("img", { attrs: { src: "/img/cash2.svg", alt: "" } }),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v("In average our customers save 2000 Kr/year")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway max-max" }, [
        _c("b", [_vm._v("Customer details")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info__blck" }, [
      _c("img", { attrs: { src: "/img/icon/waving-hand.svg", alt: "" } }),
      _vm._v(" "),
      _c("p", { staticClass: "min" }, [
        _vm._v("We will never call as irretating salepeople")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group btns " }, [
      _c("button", { staticClass: "btn btn-green btn-full" }, [
        _vm._v("continue")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-phone" }, [
      _c("p", { staticClass: "max-max p-center p-bold" }, [
        _vm._v("Hi Peter, är de du som är Peter?")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("button", { staticClass: "btn btn-green btn-full" }, [
              _vm._v("Yes")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("button", { staticClass: "btn btn-gray btn-full" }, [
              _vm._v("No")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-phone" }, [
      _c("p", { staticClass: "max-max p-center p-bold" }, [
        _vm._v("Please fill in your personnummer")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group btns " }, [
      _c("button", { staticClass: "btn btn-green btn-full" }, [
        _vm._v("continue")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway max-max" }, [
        _c("b", [_vm._v("Facility information")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Area ID")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "If the consumer chooses to break the contract entered in early, the Lighthouse has the right to charge a ransom fee. This exercise fee is calculated at 20% of the agreed energy price for estimated consumption during the remaining part of the contract period plus an administrative fee of SEK 450 incl. VAT."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway max-max" }, [
        _c("b", [_vm._v("Fakturaadress")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway max-max" }, [
        _c("b", [_vm._v("Agreements Home")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox" }, [
      _c("input", { attrs: { type: "checkbox", title: "title" } }),
      _vm._v(" "),
      _c("span", { staticClass: "box" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "min p-gray2" }, [
      _vm._v("I teste test test test test test agree TecknaEl.se "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Terms")]),
      _vm._v(" and "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Privacy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox check-error" }, [
      _c("input", { attrs: { type: "checkbox", title: "title" } }),
      _vm._v(" "),
      _c("span", { staticClass: "box" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "min p-gray2" }, [
      _vm._v("I teste test test test test test agree TecknaEl.se "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Terms")]),
      _vm._v(" and "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Privacy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway max-max" }, [
        _c("b", [_vm._v("Contract information")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contract_logo" }, [
      _c("img", { attrs: { src: "/img/telinet.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "max-max p-blue" }, [_vm._v("Telinet Energi")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone" }, [
      _c("p", { staticClass: "min-min" }, [
        _c("b", [_vm._v("Org. Number:")]),
        _vm._v(" 556766-5053")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "p-light min" }, [
        _vm._v(
          "Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi"
        )
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "min", attrs: { href: "#" } }, [
        _vm._v("Read more")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min" }, [
      _c("b", [_vm._v("Binding time")]),
      _vm._v(" "),
      _c("span", { staticClass: "quest__in_icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file__list" }, [
      _c("div", { staticClass: "file__item" }, [
        _c("img", { attrs: { src: "/img/icon/pdf.svg", alt: "" } }),
        _vm._v(" "),
        _c("a", { staticClass: "min", attrs: { href: "#" } }, [
          _vm._v("Contract terms Telinet Energi")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "file__item" }, [
        _c("img", { attrs: { src: "/img/icon/pdf.svg", alt: "" } }),
        _vm._v(" "),
        _c("a", { staticClass: "min", attrs: { href: "#" } }, [
          _vm._v("Contract terms Telinet Energi")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "file__item" }, [
        _c("img", { attrs: { src: "/img/icon/pdf.svg", alt: "" } }),
        _vm._v(" "),
        _c("a", { staticClass: "min", attrs: { href: "#" } }, [
          _vm._v("Contract terms Telinet Energi")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min-min p-white" }, [
      _vm._v("Show details "),
      _c("img", { attrs: { src: "/img/icon/arrow-down-white.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "less_price" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6 col-md-6 col-lg-7" }, [
          _c("div", { staticClass: "total" }, [
            _c("p", { staticClass: "p-blue" }, [_vm._v("Total:")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6 col-lg-5" }, [
          _c("div", { staticClass: "total-cost" }, [
            _c("p", { staticClass: "p-yellow" }, [_vm._v("45.90")]),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [_vm._v("öre / kWh incl")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox" }, [
      _c("input", { attrs: { type: "checkbox", title: "title" } }),
      _vm._v(" "),
      _c("span", { staticClass: "box" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "min p-gray2" }, [
      _vm._v("I agree teste test test test test test TecknaEl.se "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Terms")]),
      _vm._v(" and "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("Privacy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center done-btn" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "button",
          { staticClass: "btn btn-green btn-full btn-green-disabled" },
          [_vm._v("Done")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }